import { Dialog } from "@sembark-travel/ui-dialog"
import { AIParsingStatus } from "./store"
import { Alert, Button, Text } from "@sembark-travel/ui-base"
import { Link, Navigate } from "@sembark-travel/ui-router"
import { generatePath, useNavigate } from "../router-utils"
import { useState } from "react"
import ItineraryLoader from "./itinerary-loader"

interface IProps {
	status: AIParsingStatus
	tripId: string
	retry?: () => void
}

export function RetryOrShowParsingSpinner({ status, tripId, retry }: IProps) {
	if (status === "failed") {
		return <FailedAndRetry retry={retry} tripId={tripId} />
	}
	return <ItineraryLoader status={status} tripId={tripId} />
}

export function FailedAndRetry({
	tripId,
	retry,
}: {
	tripId: string
	retry?: () => void
}) {
	const [retryCount, setRetryCount] = useState(0)
	const navigation = useNavigate()

	function onClose() {
		navigation("/trips/:tripId", { params: { tripId } })
	}

	//here in case if retry reach limit then redirect user
	if (retryCount >= 2) {
		return <Navigate to={generatePath("/trips/:tripId", { tripId })} replace />
	}

	return (
		<>
			<Dialog onClose={onClose} open>
				<Dialog.Header>
					<Dialog.Title color={"danger"}>Unable to Parse Package</Dialog.Title>
				</Dialog.Header>
				<Dialog.Body gap={"4"} display={"flex"} flexDirection={"col"}>
					<Alert status="error">We couldn't parse the uploaded package.</Alert>
					<Text color="muted">
						This package couldn't be parsed. Please try uploading the package
						again. If the issue persists, verify that the file is in a supported
						format and try a different package.
					</Text>
				</Dialog.Body>

				<Dialog.Footer>
					{retry && (
						<Button
							onClick={() => {
								setRetryCount((count) => count + 1)
								retry()
							}}
						>
							Retry Parsing
						</Button>
					)}

					<Button
						as={Link}
						level="tertiary"
						to={generatePath("/trips/:tripId", { tripId })}
					>
						Upload Another Package
					</Button>
				</Dialog.Footer>
			</Dialog>
		</>
	)
}
